exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fc .fc-timegrid-col.fc-day-today {\n    background-color: #fff !important;\n}\n\n", ""]);

// exports
